import { ReactComponent as BellIcon } from '../../assets/bell.svg';
import React from 'react';
import { notificationStateUnreadItems } from '../../atoms/notificationAtom';
import { useRecoilValue } from 'recoil';

export default function NotificationsCounter() {
  const notificationStateUnreadItemsState = useRecoilValue(notificationStateUnreadItems);

  return (
    <div className="notification-counter">
      <BellIcon className="notifications-counter__icon icon icon--medium icon--brightness" />
      {notificationStateUnreadItemsState.items.length > 0 && (
        <span className="notification-counter__value">
          {notificationStateUnreadItemsState.items.length}
        </span>
      )}
    </div>
  );
}
